import Vue from "vue";
import axios from "@/configuration/axios";

const mixin = function(Vue) {
  Vue.mixin({
    created() {
      this.$axios = axios;
    },
  });
};

Vue.use(mixin);
